/**
 * <img src={trip.driverInfo?.avatar || trip.riderInfo?.avatar} width="40px" height="40px" style={{ borderRadius: "50%" }}
 **/


const ProfilePicture = ({trip}) => {

    let src = "", alt = ""
    if (trip.driverInfo) {
        src = trip.driverInfo.avatar ? trip.driverInfo.avatar : "/assets/avatarnogender.svg"
        alt = "driver pic"
    } else {
        // RIDER INFO
        if (trip.riderInfo?.avatar) {
            src = trip.riderInfo?.avatar
        } else {
            src = trip.riderInfo?.isRydePlusMember ? "/assets/avatarnogender.svg" :"/assets/Ryde_Member Profile.svg"
        }
        alt = "rider pic"
    }

    return <img src={src} width="40px" height="40px" style={{ borderRadius: "50%" }} alt={alt}/>
}

export default ProfilePicture;
